<svg *ngIf="isShowButtonSpinner" class="loader-spinner-small" viewBox="0 0 100 100">
	<circle class="loader-spinner-path" cx="50" cy="50" r="20" fill="none" stroke-width="5"></circle>
</svg>
